import { NgModule } from '@angular/core';
import { HighchartsChartModule } from 'highcharts-angular';

import { CommonUIModule, SharedUiModule } from '@shared-ui';

import { SharedDependenciesModule } from '../../shared/shared-dependencies.module';

import { DevicesListComponent } from './devices-list/devices-list.component';
import { DiagnosticsCloseButtonComponent } from './diagnostics-close-button/diagnostics-close-button.component';
import { DiagnosticsConnectionBoxComponent } from './diagnostics-connection-box/diagnostics-connection-box.component';
import { DiagnosticsConnectionForceDisconnectComponent } from './diagnostics-connection-box/diagnostics-connection-modal/diagnostics-connection-force-disconnect/diagnostics-connection-force-disconnect.component';
import { DiagnosticsConnectionModalComponent } from './diagnostics-connection-box/diagnostics-connection-modal/diagnostics-connection-modal.component';
import { DiagnosticsConnectionReasonCollectorFormComponent } from './diagnostics-connection-box/diagnostics-connection-modal/diagnostics-connection-reason-collector-form/diagnostics-connection-reason-collector-form.component';
import { DiagnosticsConnectionReasonCollectorComponent } from './diagnostics-connection-box/diagnostics-connection-modal/diagnostics-connection-reason-collector/diagnostics-connection-reason-collector.component';
import { DiagnosticsConnectionWarningComponent } from './diagnostics-connection-box/diagnostics-connection-modal/diagnostics-connection-warning/diagnostics-connection-warning.component';
import { DiagnosticsConnectionStatusComponent } from './diagnostics-connection-status/diagnostics-connection-status.component';
import { DiagnosticsOverlayComponent } from './diagnostics-overlay.component';
import { DiagnosticsTabsComponent } from './diagnostics-tabs/diagnostics-tabs.component';
import { FeaturesNotAvailableBoxComponent } from './features-not-available-box/features-not-available-box.component';
import { LegacyDeviceBoxComponent } from './legacy-device-box/legacy-device-box.component';
import { LockedSystemErrorBannerComponent } from './locked-system-error-banner/locked-system-error-banner.component';
import { NoGtsDataBoxComponent } from './no-gts-data-box/no-gts-data-box.component';
import { NoPermissionBoxComponent } from './no-permission-box/no-permission-box.component';
import { BackupModule } from './tabs-content/backup/backup.module';
import { DiagnosticsChartComponent } from './tabs-content/extended-parameters/diagnostics-chart/diagnostics-chart.component';
import { DiagnosticsStickyChartPanelComponent } from './tabs-content/extended-parameters/diagnostics-sticky-chart-panel/diagnostics-sticky-chart-panel.component';
import { DiagnosticsModule } from './tabs-content/extended-parameters/diagnostics.module';
import { GuidedTroubleshootingModule } from './tabs-content/guided-troubleshooting/guided-troubleshooting.module';
import { HydraulicSchematicsModule } from './tabs-content/hydraulic-schemes/hydraulic-schematic.module';
import { SnapshotModule } from './tabs-content/snapshot/snapshot.module';

@NgModule({
  imports: [
    SharedDependenciesModule,
    DiagnosticsModule,
    GuidedTroubleshootingModule,
    HydraulicSchematicsModule,
    BackupModule,
    SnapshotModule,
    CommonUIModule,
    SharedUiModule,
    HighchartsChartModule,
  ],
  exports: [
    DiagnosticsOverlayComponent,
    DiagnosticsConnectionForceDisconnectComponent,
    DevicesListComponent,
  ],
  declarations: [
    DiagnosticsOverlayComponent,
    DiagnosticsConnectionBoxComponent,
    DiagnosticsConnectionModalComponent,
    DiagnosticsConnectionWarningComponent,
    DiagnosticsCloseButtonComponent,
    DiagnosticsTabsComponent,
    DiagnosticsConnectionStatusComponent,
    NoGtsDataBoxComponent,
    LegacyDeviceBoxComponent,
    DiagnosticsConnectionForceDisconnectComponent,
    NoPermissionBoxComponent,
    LockedSystemErrorBannerComponent,
    FeaturesNotAvailableBoxComponent,
    DevicesListComponent,
    DiagnosticsConnectionReasonCollectorComponent,
    DiagnosticsConnectionReasonCollectorFormComponent,
    DiagnosticsChartComponent,
    DiagnosticsStickyChartPanelComponent,
  ],
  providers: [],
})
export class DiagnosticsOverlayModule {}
